import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrForgetPasswordInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-lock-open', title: 'ITR Forgot Password', subtitle: 'Reset password for an existing ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'password', label: 'New Password', icon: 'pi-lock', placeholder: 'Enter new password', maxLength: 64, htmlType: 'password' },
        ]}
        endpoint={{
            path: '/surepass/itr/forget-password',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), password: v.password, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-forget-password"
        submitLabel="Reset Password"
        successSummary="Password reset"
        errorSummary="Password reset failed"
        confirmHeader="Confirm password reset"
        confirmAcceptLabel="Yes, reset"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Password Reset', icon: 'pi-lock-open' }}
    />
);

export default ItrForgetPasswordInputComponent;
